import React from 'react';

import { ProfilePage } from '../components/profile-page';
import { ProfileState } from '../state/profile-state';

export const ProfileRoute = () => (
  <ProfileState>
    <ProfilePage />
  </ProfileState>
);
